import { useActionState, useCallback } from "react";
import { useNavigateWithSearch } from "hooks/useNavigateWithSearch";
import { useQuote } from "hooks";
import { ROUTES } from "routes/constants";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { savePaymentInformation } from "store/application/applicationSlice";
import { SavePaymentMethod } from "@aaa-life/universal-payments";
import { ENVIRONMENT_CLASS } from "env";

const PaymentInformationPage = () => {
    // ========== Hooks ==========
    const navigate = useNavigateWithSearch();
    const dispatch = useAppDispatch();
    const { quoteData } = useQuote();
    const contactData = useAppSelector((state) => state.application.contactData);

    // ========== Event Handlers ==========
    const handleBack = useCallback(() => {
        navigate(ROUTES.APPLICATION.CONTACT);
    }, [navigate]);

    // ========== OneInc Handlers ==========
    const initialState = { success: false };
    const [, formAction] = useActionState(async (prevState: typeof initialState, event: CustomEvent) => {
        const { tokenId, lastFourDigits, paymentCategory } = event.detail;
        dispatch(
            savePaymentInformation({
                paymentToken: tokenId,
                paymentType: paymentCategory === "CreditCard" ? "CC" : "ET",
                lastFourDigits,
            })
        );
        navigate(ROUTES.APPLICATION.REVIEW);
        return { ...prevState, success: true };
    }, initialState);

    const handleOneIncSuccess = () => {
        console.info("OneInc modal unloaded");
    };

    const handleError = (e: any) => {
        navigate(ROUTES.SOMETHING_WENT_WRONG);
        console.error("error", e.detail);
    };

    // ========== Computed Values ==========
    const minAmountDue = String(quoteData?.selectedCoverageAmount ?? 0);
    const referenceNumber = contactData?.policyNumber ?? "";
    // prd and pre must be empty string for one inc modal
    const getPaymentSubdomainPrefix = () => {
        switch (ENVIRONMENT_CLASS) {
            case "prd":
            case "pre":
                return "";
            case "loc":
                return "dev";
            default:
                return ENVIRONMENT_CLASS;
        }
    };
    const subdomainPrefix = getPaymentSubdomainPrefix();

    // ========== Render ==========
    return (
        <>
            <title>Payment Info | AAA Life</title>
            <SavePaymentMethod
                subdomainPrefix={subdomainPrefix}
                minAmountDue={minAmountDue}
                referenceNumber={referenceNumber}
                handleSuccess={handleOneIncSuccess}
                handleError={handleError}
                handleSaveComplete={formAction as EventListener}
                handleSaveCanceled={handleBack}
            />
        </>
    );
};

export { PaymentInformationPage };
export default PaymentInformationPage;
